module.exports = __webpack_public_path__ + "static/media/swords-laser.c0ddbea2.svg";